import { addMonths, startOfDay, startOfMonth } from "date-fns";

// No analytics exist before this date
export const MIN_ANALYTICS_DATE = new Date(2020, 3);
// Maximum selectable date is last month
export const MAX_ANALYTICS_DATE = startOfMonth(addMonths(startOfDay(new Date()), -1));

export const MAX_ANALYTICS_PERCENTAGE_VALUE = 100;
